import type { MouseEvent } from "react";

import { translate } from "app/filters/i18nFilter";
import { ApplyButton } from "app/pages/activation/components/ApplyButton/ApplyButton";
import { MAX_COMPETITORS } from "app/pages/activation/components/RankWidget/config";
import { modalsTexts } from "app/pages/activation/components/RankWidget/texts";

import { CompetitorsDropdownKeys } from "./dataAutomationKeys";
import { APPLY_TEXT } from "./texts";

type FooterSchema = {
    isSomeSelected: boolean;
    isMaxSelected: boolean;
    onApply: (event: MouseEvent<HTMLDivElement>) => void;
};

export const Footer = ({ isSomeSelected, isMaxSelected, onApply }: FooterSchema) => {
    if (!isSomeSelected) {
        return null;
    }

    return (
        <ApplyButton
            onClick={onApply}
            text={translate(APPLY_TEXT)}
            tooltipProps={{
                enabled: isMaxSelected,
                content: translate(modalsTexts.competitorsDropdownApplyTooltip, { max: MAX_COMPETITORS }),
                children: translate(APPLY_TEXT),
            }}
            dataAutomation={CompetitorsDropdownKeys.applyButton}
        />
    );
};
